var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.jobVisible && _setup.job?.worker_count > 0)?_c(_setup.JobsPromo,{attrs:{"job":_setup.job},on:{"dismiss":_setup.dismiss}}):(_setup.shiftVisible && _setup.shift?.worker_count > 0)?_c(_setup.ShiftsPromo,{attrs:{"shift":_setup.shift},on:{"dismiss":_setup.dismiss}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }